import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { Button, ButtonVariant, Modal } from '@makyoapp/makyo-ui'

import { useCurrentOrgContext } from '@/context/CurrentOrgContext'
import { useStorageContext } from '@/context/StorageContext'
import { ACCEPTED_FILE_TYPES } from '@/shared/constants'

interface UploadErrorModalProps {
  show: boolean
  errorTitle?: string
  error?: React.ReactNode
  onClose: () => void
  onRetry: (e: React.ChangeEvent<HTMLInputElement>, orgId: string, folderId: string) => void
}

const UploadErrorModal = ({ show, errorTitle, error, onClose, onRetry }: UploadErrorModalProps) => {
  const { t } = useTranslation()
  const { currentOrg } = useCurrentOrgContext()
  const { currentFolderId } = useStorageContext()

  return (
    <Modal show={show}>
      <Modal.Header onCloseClick={onClose}>{t(errorTitle ?? 'Upload Error')}</Modal.Header>
      <Modal.Body className='modal-sm'>
        <div className='py-2'>{error ?? t('The selected file type is not allowed, please try with another file.')}</div>
      </Modal.Body>
      <Modal.Footer className='flex justify-between'>
        <Button variant={ButtonVariant.Outlined} onClick={onClose}>
          {t('Close')}
        </Button>

        <label className='cursor-pointer relative'>
          <input
            className='sr-only'
            type='file'
            accept={ACCEPTED_FILE_TYPES.join(',')}
            multiple
            onChange={(e) => {
              if (currentOrg) {
                onRetry(e, currentOrg.id, currentFolderId)
              }
              // reset element ref to enable reupload after upload error
              e.target.value = ''
            }}
          />
          <Button className='pointer-events-none'>
            <span className='material-symbols-rounded text-[1rem]!'>repeat</span>
            <Trans>Retry Upload</Trans>
          </Button>
        </label>
      </Modal.Footer>
    </Modal>
  )
}

export default UploadErrorModal
